import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=7841fd4e&"
import script from "./TableHeader.vue?vue&type=script&lang=js&"
export * from "./TableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports